// /components/composer/useComposer.js
import { createContext, useContext } from 'react';

export const ComposerCtx = createContext({ openComposer: () => {} });

export function useComposer() {
  return useContext(ComposerCtx);
}
